module.exports = __webpack_public_path__ + "videos/filters_cn.259ab9f.mp4";